
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summer",
      function () {
        return require("private-next-pages/summer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summer"])
      });
    }
  